import { ApiService } from "./apiService";

export const getDiscussionNotes = async (userId: number, procedureId: number, page: number, pageSize: number) => {
  const { data } = await ApiService.get(`users/${userId}/procedures/${procedureId}/discussion_notes?page=${page}&page_size=${pageSize}`);
  return data;
};

export const addDiscussionNote = async (userId: number, procedureId: number, note: string) => {
  const { data } = await ApiService.post(`users/${userId}/procedures/${procedureId}/discussion_notes`, { note });
  return data;
};

export const updateDiscussionNote = async (userId: number, procedureId: number, noteId: number, note: string) => {
  return await ApiService.put(`users/${userId}/procedures/${procedureId}/discussion_notes/${noteId}`, { note });
};

export const deleteDiscussionNote = async (userId: number, procedureId: number, noteId: number) => {
  return await ApiService.delete(`users/${userId}/procedures/${procedureId}/discussion_notes/${noteId}`);
};
